import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";
import { Panel,
          Row,
          Col,
          Button,
          FormGroup,
          Tabs,
          Tab,
          FormControl,
          ControlLabel,
          Table,
          Checkbox,
          Glyphicon,
          Modal,
          ButtonGroup,
          DropdownButton,
          MenuItem,
          Tooltip,
          OverlayTrigger} from "react-bootstrap";
import Truncate from 'react-truncate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {ToastContainer, ToastStore} from 'react-toasts';
import _ from "underscore";
import $ from "jquery";
import moment from 'moment';
import FormsService from "../../services/forms-service";

import FormCanvas from './canvas';
import DetailPanel from './detail-panel';
import ToolBar from './toolbar';
//Props:
//mode: edit/fill/fillUpdate/readOnly/pdfPreview
//onSave: function for saving form
//forms
//clients
var antiConvolutionTimeout = null; //When clicking move up or down, accidentally clicks the replaced element.
var readyToRecieveInput = true;

class ArchonFormBuilder extends Component {

  constructor(props, context) {
      super(props, context);
      this.state = {
        formName: "Standard Form Name",
        imagesToUpload: [],
        elements: [],
        cloneGroups: {},//List of cloneGroups and their count. ex: {"Occurrence": 2}. Updated on repeatElement and deleteElement.
                        //The idea is to keep track of number of clones, so that new clones would be at index original.index + cloneGroup[cloneGroup name].length - 1
                        //New clones must be appended after existing clones.
        selectedElement: null,
        selectedIndex: null,
        selectedId: null,
        showToolBar: true,
        formToEdit: null,
      }

      this.addElement = this.addElement.bind(this);
      this.removeElement = this.removeElement.bind(this);
      this.selectElement = this.selectElement.bind(this);
      this.updateElement = this.updateElement.bind(this);
      this.moveElement = this.moveElement.bind(this);
      this.repeatElement = this.repeatElement.bind(this);
      this.setImagesToUpload = this.setImagesToUpload.bind(this);
  }

  render() {
    var isEditMode = this.props.mode === "edit" ? true : false;
    var validFormList = _.filter(this.props.forms, (form)=>{
      return (form.json_string != "" && form.json_string != null)
    })

    return <Col>
              { isEditMode
                  ? <Row>

                        <Col className="col-md-4">
                          <FormGroup style={{padding: 30}} controlId="formName" className="col-md-12" >
                              <ControlLabel className="login_label">Form Name</ControlLabel>
                              <FormControl
                                  autoFocus
                                  type="text"
                                  value={this.state.formName}
                                  onChange={(e)=>{this.setState({formName: e.currentTarget.value})}}
                              />
                              <br/>
                              <Button onClick={()=>{
                                                                this.props.onSave({
                                                                    formName: this.state.formName,
                                                                    facilityId: this.state.facilityId,
                                                                    facilityName: this.state.facilityName,
                                                                    branchName: this.state.branchName,
                                                                    branchId: this.state.branchId,
                                                                    clientName: this.state.clientName,
                                                                    clientId: this.state.clientId,
                                                                    elements: JSON.stringify(this.state.elements)});}}>Save Form</Button>
                          </FormGroup>
                        </Col>
                        <Col className="col-md-3">
                            <FormGroup style={{padding: 30}} controlId="formName" className="row-md" >
                                <ControlLabel className="login_label">Load From Form</ControlLabel>
                                <FormControl  componentClass="select"
                                              defaultValue={""}
                                              value={this.state.formToEdit ? this.state.formToEdit.name : ""}
                                              onChange={(e)=>{
                                                var formToEdit = validFormList[e.currentTarget.value];

                                                this.reloadWithNewForm(formToEdit);

                                                            // this.setState({
                                                            //     formName: validFormList[e.currentTarget.value].form_name,
                                                            //     formToEdit:  validFormList[e.currentTarget.value],
                                                            //     elements:  JSON.parse(validFormList[e.currentTarget.value].json_string)})
                                                        }}>
                                {validFormList == null || validFormList.length <= 0
                                  ? <option key={""} value={""} disabled selected>No Forms Available</option>
                                  : <option key={""} value={""} disabled selected>Select Form</option>}
                                {validFormList.map((form, index) => {
                                      return <option key={index} value={index}>{form.form_name}</option>
                                  })
                                }
                                </FormControl>
                                <br/>
                                <ControlLabel className="login_label">Client</ControlLabel>
                                <FormControl  componentClass="select"
                                              defaultValue={""}
                                              value={this.state.clientIndex}
                                              onChange={(e)=>{
                                                            this.setState({
                                                              clientName: this.props.clients[e.currentTarget.value].client_name,
                                                              clientId: this.props.clients[e.currentTarget.value].id,
                                                              clientIndex: e.currentTarget.value,
                                                            })}}>
                                {this.props.clients == null || this.props.clients.length <= 0
                                  ? <option key={""} value={""} disabled selected>No Clients Available</option>
                                  : <option key={""} value={""} disabled selected>Select Client</option>}
                                {this.props.clients.map((client, index) => {
                                      if(client.is_active === "1") {
                                        return <option key={index} value={index}>{client.client_name}</option>
                                      }

                                  })
                                }
                                </FormControl>
                                <br/>

                            </FormGroup>
                        </Col>

                          <Col className="col-md-3">
                            <FormGroup style={{padding: 30}} controlId="formName" className="row-md" >
                              <ControlLabel className="login_label">Facility</ControlLabel>
                              <FormControl  componentClass="select"
                                            defaultValue={""}
                                            value={this.state.facilityIndex}
                                            onChange={(e)=>{
                                                          this.setState({
                                                            facilityName: this.props.facilities[e.currentTarget.value].facility_name,
                                                            facilityId: this.props.facilities[e.currentTarget.value].facility_id,
                                                            facilityIndex: e.currentTarget.value,
                                                          })}}>
                              {this.props.facilities == null || this.props.facilities.length <= 0
                                ? <option key={""} value={""} disabled selected>No Facility Available</option>
                                : <option key={""} value={""} disabled selected>Select Facility</option>}
                              {this.props.facilities.map((facility, index) => {
                                    if(facility.is_active === "1") {
                                      return <option key={index} value={index}>{facility.facility_name}</option>
                                    }
                                })
                              }
                              </FormControl>
                              <br/>
                              <ControlLabel className="login_label">Branch</ControlLabel>
                              <FormControl  componentClass="select"
                                            defaultValue={""}
                                            value={this.state.branchIndex}
                                            onChange={(e)=>{
                                                          this.setState({
                                                            branchName: this.props.branches[e.currentTarget.value].branch_name,
                                                            branchId: this.props.branches[e.currentTarget.value].id,
                                                            branchIndex: e.currentTarget.value,
                                                          })}}>
                              {this.props.branches == null || this.props.branches.length <= 0
                                ? <option key={""} value={""} disabled selected>No Branches Available</option>
                                : <option key={""} value={""} disabled selected>Select Branch</option>}
                              {this.props.branches.map((branch, index) => {
                                  if(branch.is_active === "1") {
                                    return <option key={index} value={index}>{branch.branch_name}</option>
                                  }

                                })
                              }
                              </FormControl>
                            </FormGroup>
                          </Col>

                      </Row>
                  : null
              }
              <Row>
                <Col md={isEditMode ? 9 : 12}>
                  <FormCanvas elements={this.state.elements}
                              removeElement={this.removeElement}
                              selectElement={this.selectElement}
                              moveElement={this.moveElement}
                              updateElement={this.updateElement}
                              mode={this.props.mode}
                              selectedIndex={this.state.selectedIndex}
                              selectedId={this.state.selectedId}
                              onSave={this.props.onSave}
                              repeatElement={this.repeatElement}
                              setImagesToUpload={this.setImagesToUpload}
                              imagesToUpload={this.state.imagesToUpload}
                              clients={this.props.clients}/>
                </Col>
                { isEditMode
                  ? <Col md={2}>
                      <ButtonGroup className="mt-3">
                          <Button variant="secondary" className={this.state.showToolBar ? 'active':''} onClick={()=>{this.setState({showToolBar: true})}}>Toolbar</Button>
                          <Button variant="secondary" className={this.state.showToolBar ? '':'active'} onClick={()=>{this.setState({showToolBar: false})}}>Details</Button>
                      </ButtonGroup>

                      <br/>
                      <br/>
                      { this.state.showToolBar
                          ? <ToolBar addElement={this.addElement} />
                          : <DetailPanel element={this.state.selectedElement}
                                selectedIndex={this.state.selectedIndex}
                                updateElement={this.updateElement}
                                clients={this.props.clients}/>
                      }

                    </Col>
                    : null
                }
              </Row>
            </Col>;
  }

  setImagesToUpload(images) {
    this.setState({
      imagesToUpload: images.slice()
    })
  }

  componentDidMount() {

    $(document).keyup((e)=>{
      if(e.key === "Escape") {
        this.setState({
          selectedElement: null,
          selectedIndex: null
        })
      }
    })
    if(this.props.formToEdit != null) {
      this.reloadWithNewForm(this.props.formToEdit);
    }


  }

  componentDidUpdate() {
    var formToEdit = this.props.formToEdit;
    if(formToEdit != null && JSON.stringify(formToEdit) != JSON.stringify(this.state.formToEdit)) {
      this.reloadWithNewForm(this.props.formToEdit);
    }
  }

  selectElement(index, id, parentElement, isForRepeatFunction) {

    if(readyToRecieveInput && (this.props.mode == 'edit' || isForRepeatFunction)) {
      this.setState({
        selectedElement: parentElement ? parentElement.children[index] : this.state.elements[index],
        selectedIndex: index,
        selectedId: parentElement != null ? parentElement.children[index].id : id,
        showToolBar: false,
      })
    }
  }

  addElement(element, index) {
    var newElements = this.state.elements.slice();


    var newSelectedElement = this.state.selectedElement ? JSON.parse(JSON.stringify(this.state.selectedElement)) : null;

    if(newSelectedElement != null &&
                (newSelectedElement.type == "column" || newSelectedElement.type == "row" || newSelectedElement.type == "container")) {

                  if(element.type == "column" || element.type == "row" || element.type == "container") {
                      ToastStore.error("Cannot support a container type inside a container type yet!", 5000);
                  } else {
                    if(index != null) {
                      newSelectedElement.children.splice(index, 0, element);
                    } else {
                      newSelectedElement.children.push(element);
                    }

                    var customParentElement = JSON.parse(JSON.stringify(newSelectedElement));
                    var newChildren = [];
                    //customParentElement.children.push(element);
                    //Remove parentElement from children, so as to stop the object from turning circular
                    customParentElement.children.map((child)=>{
                      if(child.parentElement) {
                        delete child.parentElement;
                      }
                      newChildren.push(child);
                    })

                    customParentElement.children = newChildren;
                    newSelectedElement.children.map((child)=>{
                      child.parentElement = customParentElement;
                    })

                    var heirarchyToUpdate = this.getHeirarchyToUpdate(newSelectedElement);

                    var index = this.state.elements.indexOf(_.find(this.state.elements, (element)=>{
                      return element.id == heirarchyToUpdate.id
                    }));

                    this.updateElement(index, heirarchyToUpdate);
                    this.setState({
                      selectedElement: newSelectedElement,
                    })
                  }


    } else {
      if(index != null) {
        newElements.splice(index, 0, element);
      } else {
        newElements.push(element);
      }
      this.setState({
        elements: newElements
      });
    }

  }

  removeElement(index, parentElement, cloneGroup) {
    var newElements = this.state.elements.slice();
    var disabled = this.props.mode === "edit" || this.props.mode === "readOnly";

    if(parentElement == null) {
      newElements.splice(index, 1);

      this.triggerUIDelay();
      this.setState({
        elements: newElements,
        selectedElement: null,
        selectedIndex: null,
      })

    } else {
      var customParentElement = JSON.parse(JSON.stringify(parentElement));
      var newChildren = [];
      customParentElement.children.map((child)=>{
        if(child.parentElement) {
          delete child.parentElement.children;
        }
        newChildren.push(child);
      })
      customParentElement.children = newChildren;
      customParentElement.children.splice(index, 1);

      this.updateHeirarchy(index, customParentElement);

    }

    if(cloneGroup != null) {
      var existingCloneGroups = JSON.parse(JSON.stringify(this.state.cloneGroups));
      if(existingCloneGroups[cloneGroup] != null) {
        existingCloneGroups[cloneGroup] = existingCloneGroups[cloneGroup] - 1;
      } else {
        existingCloneGroups[cloneGroup] = 0;
      }
      this.setState({
        cloneGroups: existingCloneGroups
      });
    }

  }

  updateElement(index, element, parentElement) {
    //Update parentElements of ALL children. issue is that only 1 element has updated parentElement

    var newElements = this.state.elements.slice();

    if(parentElement == null) {

      newElements.splice(index,1,element);

      var newState = {elements: newElements};

      if(index == this.state.selectedIndex) {
        newState["selectedId"] = element.id;
        newState["selectedElement"] = newElements[index];
      }
      this.setState(newState)

    } else {
      parentElement.children[index] = element;

      var customParentElement = this.createCustomParentElement(parentElement);//JSON.parse(JSON.stringify(parentElement));
      var newChildren = [];
      // customParentElement.children.map((child)=>{
      //   if(child.parentElement != null) {
      //       delete child.parentElement;
      //   }
      //   newChildren.push(child);
      // })
      // customParentElement = newChildren;
      parentElement.children.map((child)=>{
        child.parentElement = customParentElement;
      })
      this.updateHeirarchy(index, parentElement);
      this.selectElement(index, parentElement.children[index].id, parentElement);
    }


  }

  moveElement(index, movement, parentElement) {
    if(readyToRecieveInput) {
      var newIndex = index + movement;
      var elements = this.state.elements.slice();

      if(parentElement != null) {
        elements = parentElement.children.slice();
      }

      var elementToMove = elements[index];
      var otherElement = null;

      if(newIndex < elements.length && newIndex >= 0) {
        otherElement = elements[newIndex];
        elements.splice(index, 1, otherElement);
        elements.splice(newIndex, 1, elementToMove);
      } else {
        newIndex = index;
      }

      if(parentElement != null) {
        parentElement.children = elements.slice();
        this.updateHeirarchy(newIndex, parentElement);
        this.selectElement(newIndex, parentElement.children[newIndex].id, parentElement);
        //this.setState({ selectedIndex: newIndex, selectedElement: parentElement[newIndex]})
      } else {
        this.setState({elements: elements, selectedIndex: newIndex, selectedElement: elements[newIndex]})
      }
      this.triggerUIDelay();

    }
  }

  repeatElement(cloneGroup) {
    var dataToClone = this.getCloneGroupField(this.state.elements, cloneGroup);
    if(dataToClone != null) {

      var newElement = JSON.parse(JSON.stringify (dataToClone.element));
      //newElement.cloneGroup.value = "None";
      newElement.id = newElement.type + "_" + new Date().getTime() + "_" + (dataToClone.index + 1);
      newElement.isClone = true;
      if(newElement.children != null) {
        var customParentElement = this.createCustomParentElement(newElement);
        newElement.children.map((child, i)=>{
          child.id = child.type + "_" + new Date().getTime() + "_" + i;
          child.parentElement = customParentElement;
          //Add newElement as this child's parentElement. Issue was, child's parentElement is still dataToClone.element
        });
      }
      var existingCloneGroups = JSON.parse(JSON.stringify(this.state.cloneGroups));
      if(existingCloneGroups[cloneGroup] != null) {
        existingCloneGroups[cloneGroup] = existingCloneGroups[cloneGroup] + 1;
      } else {
        existingCloneGroups[cloneGroup] = 1;
      }

      // this.selectElement(dataToClone.index, dataToClone.element.id, dataToClone.parentElement, true);
      this.addElement(newElement, dataToClone.index + 1);
      this.setState({
        cloneGroups: existingCloneGroups
      });
    } else {
      ToastStore.warning("Could not find a field with cloneGroup: " + cloneGroup, 5000);
    }
  }

  triggerUIDelay() {
    //when we move elements, the new element gets clicked immediately,
    //resulting to an unwanted selectElement() call. We add a delay. -Tere
    readyToRecieveInput = false;

    if(antiConvolutionTimeout != null) {
      clearTimeout(antiConvolutionTimeout);
    }

    antiConvolutionTimeout = setTimeout(()=>{
      readyToRecieveInput = true;
    }, 500);
  }

  updateHeirarchy(index, parentElement) {

    //heirarchyToUpdate is the root element of the element to be updated
    var heirarchyToUpdate = this.getHeirarchyToUpdate(parentElement);

    var index = this.state.elements.indexOf(_.find(this.state.elements, (element)=>{
      return element.id == heirarchyToUpdate.id
    }));
    this.updateElement(index, heirarchyToUpdate);
  }

  getHeirarchyToUpdate(element) {

    var heirarchy = element;

    heirarchy = this.getHeirarchy(element, heirarchy);

    return heirarchy;
  }

  getHeirarchy(element, heirarchy) {
    if(element.parentElement != null) {
      // heirarchy.push(element.parentElement);
      var parentElement = element.parentElement;
      var index = parentElement.children.indexOf(_.find(parentElement.children, (child)=>{ return child.id == element.id}));
      parentElement.children.splice(index, 1, element);
      var newChildren = [];
      parentElement.children.map((child)=>{
        delete child.parentElement.children;
        newChildren.push(child);
      });
      parentElement.children = newChildren;
      heirarchy = this.getHeirarchy(parentElement, parentElement);
    }

    return heirarchy;

  }

  //Warning: Can only find CloneGroup at the first level of heirarchy
  getCloneGroupField(elementList, cloneGroup) {
    var foundMatch = false;
    var elementMatch = null;
    var index = 0;

    //Loop around own children to try and find cloneGroup. Only 1 level only
    elementList.map((element, i)=>{

      if(element.cloneGroup && element.cloneGroup.value === cloneGroup) {
        elementMatch = element;
        foundMatch = true;
        index = i;
      }
      // if(!foundMatch && element.children != null) {
      //
      //   elementMatch = this.getCloneGroupField(element.children, cloneGroup);
      //
      //   if(elementMatch != null) {
      //     foundMatch = true;
      //     index = i;
      //   }
      // }

    });



    //If not found, loop around children's children.
    // if(!foundMatch) {
    //   elementList.map((element)=>{
    //     if(element.children != null) {
    //       if(!foundMatch) {
    //         elementMatch = this.getCloneGroupField(element.children, cloneGroup);
    //       }
    //       if(elementMatch != null) {
    //         foundMatch = true;
    //       }
    //     }
    //   });
    // }
    if(foundMatch) {
      return {element: elementMatch, index: index};
    } else {
      return null
    }

  }

  createCustomParentElement(parentElement) {
    var customParentElement = JSON.parse(JSON.stringify(parentElement));
    var newChildren = [];
    customParentElement.children.map((child)=>{
      if(child.parentElement != null) {
          delete child.parentElement;
      }
      newChildren.push(child);
    });
    return customParentElement;
  }

  setImagesToUpload(images) {
    this.setState({
      imagesToUpload: images
    })

  }

  reloadWithNewForm(formToEdit) {
    var getPropertyFromList = (list, propertyToReturn, listPropertyToCompare, propertyToCompare) =>{
      var valueToReturn = null;
      var isFound = false;
      list.map((item, index)=>{
        if(!isFound && item[listPropertyToCompare] === propertyToCompare) {
          if(propertyToReturn === "index") {
            valueToReturn = index;
          } else {
            valueToReturn = item[propertyToReturn];
          }
          isFound = true;
        }
      })

      return valueToReturn;
    }


    var newState = {
      elements: formToEdit.json_string ? JSON.parse(formToEdit.json_string) : null,
      formName: formToEdit.form_name,
      formToEdit: formToEdit,
      imagesToUpload: formToEdit.attachments_data,
      //imagesToUpload: JSON.stringify([{name: "tikal", path: "https://i.kym-cdn.com/photos/images/newsfeed/001/373/328/b16.jpg"}]),//For blob testing
    }

    if(this.props.mode === "edit") {
      newState["clientName"] = formToEdit.client_name;
      newState["clientId"] = getPropertyFromList(this.props.clients, "id", "client_name", formToEdit.client_name);
      newState["clientIndex"] = getPropertyFromList(this.props.clients, "index", "client_name", formToEdit.client_name);

      newState["facilityName"] = formToEdit.facility_name;
      newState["facilityId"] = getPropertyFromList(this.props.facilities, "facility_id", "facility_name", formToEdit.facility_name);
      newState["facilityIndex"] = getPropertyFromList(this.props.facilities, "index", "facility_name", formToEdit.facility_name);

      newState["branchName"] = formToEdit.branch_name;
      newState["branchId"] = getPropertyFromList(this.props.branches, "id", "branch_name", formToEdit.branch_name);
      newState["branchIndex"] = getPropertyFromList(this.props.branches, "index", "client_name", formToEdit.branch_name);
    }
    this.setState(newState);
  }
}

export default ArchonFormBuilder;
